import React, { type FC, useState } from 'react';
import type { Types } from '@fiverr-private/theme';
import { CheckCircleIcon, WarningCircleIcon, InfoCircleIcon, type SystemIconType } from '@fiverr-private/visuals';
import { TimesButton } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import type { ToastProps, ToastType } from '../types';

const ICON_BY_TYPE: { [K in ToastType]: { icon: FC<SystemIconType>; color: Types.Color; borderColor: Types.Color } } = {
  success: { icon: CheckCircleIcon, color: 'green_1000', borderColor: 'green_900' },
  error: { icon: WarningCircleIcon, color: 'red_1000', borderColor: 'red_900' },
  info: { icon: InfoCircleIcon, color: 'blue_1000', borderColor: 'blue_900' },
};

const Toast = ({ message, type = 'info', dataTrackTag, dataTrackValue }: ToastProps) => {
  const [shouldRender, setShouldRender] = useState(true);

  if (!shouldRender) {
    return null;
  }

  const { icon: Icon, color, borderColor } = ICON_BY_TYPE[type];

  return (
    <Container
      as="span"
      display="flex"
      alignItems="center"
      height="auto"
      borderLeftWidth="xl"
      maxWidth={{ default: '85vw', sm: '392px' }}
      boxShadow="z4"
      borderColor={borderColor}
      backgroundColor="white"
      paddingY="2"
      paddingRight="2"
      borderRadius="sm"
      dataTrackTag={dataTrackTag}
      dataTrackValue={dataTrackValue}
    >
      <Container display="flex" alignItems="center" flex={1} width="max-content" marginRight="3">
        <Container as="span" display="inlineFlex" paddingRight="3" paddingLeft="4">
          <Icon color={color} />
        </Container>
        <Text fontWeight="semibold">{message}</Text>
      </Container>
      <TimesButton size="3xs" onClick={() => setShouldRender(false)} />
    </Container>
  );
};

Toast.displayName = 'Toast';

export default Toast;
